import DrugIcon from "../../images/icons/DrugIcon.svg";
import PatientProfileIcon from "../../images/icons/PatientProfileIcon.svg";
import PatientRegIcon from "../../images/icons/PatientRegIcon.svg";
import DefaultPhysicianIcon from "../../images/icons/DefaultPhysicianIcon.svg";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import PrintGIcon from "../../images/icons/PrintGIcon.svg";
import FreeTextMedicationIcon from "../../images/icons/FreeTextMedicationIcon.svg";
import NotesIcon from "../../images/icons/notes.svg";
import SaveIcon from "../../images/icons/SaveIcon.svg";
import MedicationHxIcon from "../../images/icons/MedicationHxIcon.svg";
import SavedRxIcon from "../../images/icons/SavedRxIcon.svg";
import FavDrugIcon from "../../images/icons/FavDrugIcon.svg";
import template from "../../images/template.png";
import StaffIcon from "../../images/icons/StaffIcon.svg";
import ChangePasswordIcon from "../../images/icons/ChangePasswordIcon.svg";
import SetDrugInteractionLevelIcon from "../../images/icons/SetDrugInteractionLevelIcon.svg";
import FavIcon from "../../images/icons/FavIcon.svg";
import SettingsIcon from "../../images/icons/SettingsIcon.svg";
import ClinicIcon from "../../images/icons/ClinicIcon.svg";
import MybriefCaseIcon from "../../images/icons/MybriefCaseIcon.svg";
import PrescriptionReportIcon from "../../images/icons/PrescriptionReportIcon.svg";
import UserActivityIcon from "../../images/icons/UserActivityIcon.svg";
import PatientMedicationIcon from "../../images/icons/PatientMedicationIcon.svg";
import PatientPharmaciesIcon from "../../images/icons/PatientPharmaciesIcon.svg";
import PrescriberHistoryIcon from "../../images/icons/PrescriberHistoryIcon.svg";
import PatientPrescriptionIcon from "../../images/icons/PatientPrescriptionIcon.svg";
import DashboardIcon from "../../images/icons/DashboardIcon.svg";
import ReportsIcon from "../../images/icons/ReportsIcon.svg";
import ClosexIcon from "../../images/icons/ClosexIcon.svg";
import EmailIcon from "../../images/icons/EmailIcon.min.svg";
import LocIcon from "../../images/icons/LocIcon.min.svg";
import PhoneIcon from "../../images/icons/PhoneIcon.min.svg";
import PatientProfIcon from "../../images/icons/Patient_Profile.svg";
import PharmacyProfileIcon from "../../images/icons/Pharmacy_Profile.svg";
import Allergies from "../../pages/Allergies";
import FavoriteDrugs from "../../pages/FavoriteDrugs";
import MedicationHistory from "../../pages/MedicationHistory";
import SSMedicationHistory from "../../pages/SSMedicationHistory";
import PracticeFavoriteDrugs from "../../pages/PracticeFavoriteDrugs";
import Registration from "../../pages/Registration";
import SavedPrescriptions from "../../pages/SavedPrescriptions";
import PostDatedPrescriptions from "../../pages/PostDatedPrescriptions";
import EPAHoldingQueue from "../../pages/EPAHoldingQueue";
import RxFillAlert from "../../pages/RxFillAlert";
import RxFill from "../../pages/RxFill";
import PendingRxChangeAlerts from "../../pages/PendingRxChangeAlerts";
import PendingRxChange from "../../pages/PendingRxChange";
import RxAlerts from "../../pages/RxAlerts";
import PendingRefillsAlert from "../../pages/PendingRefillsAlert";
import PendingRefills from "../../pages/PendingRefills";
import EpcsQueue from "../../pages/EpcsQueue";
import Faqs from "../../pages/Faqs";
import Ticket from "../../pages/Ticket";
import HelpCenter from "../../pages/HelpCenter";
import NotificationsList from "../../pages/Notifications";
import ChangePassword from "../../pages/ChangePassword";
import DefaultPhysician from "../../pages/DefaultPhysician";
import PatientProfile from "../../pages/PatientProfile";
import InsuranceInformation from "../../pages/InsuranceInformation";
import AllergyInformation from "../../pages/AllergyInformation";
import PharmacyInformation from "../../pages/PharmacyInformation";
import EPAWorklist from "../../pages/EPAWorklist";
import NewRxPadSingle from "../../pages/NewRxPadSingle";
import PatientSearch from "../../pages/PatientSearch";
import StaffAuthorization from "../../pages/StaffAuthorization";
import PatientPrescriptionReport from "../../pages/Reports/PatientPrescriptionReports";
import PrescriberHistoryReport from "../../pages/Reports/PrescriberHistoryReport";
import SavedPrescriptionReport from "../../pages/Reports/SavedPrescriptionReport";
import PrescriberEPCSSuccessransactions from "../../pages/Reports/PrescriberEPCSSuccessransactions";
import PrescriberEPCSFailedTransactions from "../../pages/Reports/PrescriberEPCSFailedTransactions";
import PrescriberEPCSAudit from "../../pages/Reports/PrescriberEPCSAudit";
import PatientPharmaciesReport from "../../pages/Reports/PatientPharmaciesReport";
import PatientMedicationReport from "../../pages/Reports/PatientMedicationReport";
import PendingRefillsReport from "../../pages/Reports/PendingRefillsReport";
import UserActivityReport from "../../pages/Reports/UserActivityReport";
import DrugUpdate from "../../pages/MedicationHistory/DrugUpdate";
import MedicationInactivation from "../../pages/MedicationHistory/MedicationInactivation";
import ClinicalInformation from "../../pages/ClinicalInformation";
import FavouriteDrugs from "../../pages/FavouriteDrugs";
import FreeTextMedicationSingle from "../../pages/FreeTextMedicationSingle";
import PendingRefillAlertsRequest from "../../pages/PendingRefillsAlert/PendingRefillAlertsRequest";
import PendingRefillsRequest from "../../pages/PendingRefillsRequest";
import PendingRefillsAllergyInfo from "../../pages/PendingRefillsRequest/PendingRefillsAllergyInfo";
import RxAlertsReview from "../../pages/RxAlerts/RxAlertsReview";
import RxFillReview from "../../pages/RxFill/RxFillReview";
import RxFillAlertReview from "../../pages/RxFillAlert/RxFillAlertReview";
import PendingRxChangeRequest from "../../pages/PendingRxChangeRequest";
import PendingRxChangeAllergyInfo from "../../pages/PendingRxChangeRequest/PendingRxChangeAllergyInfo";
import PendingRxChangeAlertsRequest from "../../pages/PendingRxChangeAlerts/PendingRxChangeAlertsRequest";
import CancelPrescriptions from "../../pages/MedicationHistory/CancelPrescriptions";
import ConfirmReprintRefax from "../../pages/MedicationHistory/ConfirmReprintRefax";
import PrescriptionFilled from "../../pages/SSMedicationHistory/PrescriptionFilled";
import PersonalInfo from "../../pages/PersonalInfo";
import MyBriefCase from "../../pages/MyBriefCase";
import Dashboard from "../../pages/Dashboard";
import AllSavedPrescriptions from "../../pages/AllSavedPrescriptions";
import MyAccountIcon from "../../images/icons/MyAccountIcon.svg";
import NewRxPadIcon from "../../images/icons/NewRxPadIcon.svg";
import PendingRefillsIcon from "../../images/icons/PendingRefillsIcon.min.svg";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import FaqIcon from "../../images/icons/FaqIcon.svg";
import HelpIcon from "../../images/icons/HelpIcon.svg";
import NotificationIcon from "../../images/icons/NotificationIcon.svg";
import SearchIcon from "../../images/icons/SearchIcon.svg";
import TicketIcon from "../../images/icons/TicketIcon.svg";
import EPCSAuditIcon from "../../images/icons/EPCSAuditIcon.svg";
import EPCSSuccessIcon from "../../images/icons/EPCSSuccessIcon.svg";
import EPCSFailedIcon from "../../images/icons/EPCSFailedIcon.svg";
import servingphysicians from "../../images/servingphysicians.png";
import epcs from "../../images/epcs.png";
import epa from "../../images/epa.png";
import aipma from "../../images/aipma.png";
import {
  Typography,
  IconButton,
  Tooltip,
  Grid,
  Avatar,
  Box,
} from "@mui/material";
import {
  BtnIconStyle,
  HtmlTooltip,
  InfoCard,
  PatientPharmaInfoCard,
  TooltipCardStyle,
} from "../../Theme";
import DrugDscTooltip from "../DrugDscTooltip";
import PharmacyTooltip from "../PharmacyTooltip";
import PatientTooltip from "../PatientTooltip";
import { useState } from "react";
import EPAHoldingQueueConfirmPresctiptions from "../../pages/EPAHoldingQueue/EPAHoldingQueueConfirmPrescriptions";
import PrescriptionTemplate from "../../pages/PrescriptionTemplate";
import PrescriptionTemplateInfo from "../../pages/PrescriptionTemplateInfo";
import PrescriptionTemplateDetails from "../../pages/PrescriptionTemplate/PrescriptionTemplateDetails";
import PrescriptionTemplateInfoDetails from "../../pages/PrescriptionTemplateInfo/PrescriptionTemplateInfoDetails";
import LegacyHistory from "../../pages/LegacyHistory";
import ProfileSettings from "../../pages/ProfileSettings";
import AIPrescription from "../../pages/AIPrescription";
const Year = new Date().getFullYear();
export const FooterCopyright = `© ${Year} H2H Solutions, Inc. All rights reserved.`;
export const FooterPhone = "Call on: (248)-675-1200 Extn:429,182";
export const FooterEmail = "drxsupport@h2hsolutions.com";
export const SignTitleText = "Hello!";
export const SignCaptionText = "Please enter the user Id and password";
export const ForgotTitleText = "Forgot Password?";
export const ForgotCaptionText = "Please enter your registered email ID.";
export const SignLinkText = "Forgot password?";
export const ForgotLinkText = "I have login credentials.";
export const showRxTabNav = ["prescription-summary", "newrxpad"];
export const showFreeRxTabNav = ["freetextrxpadsummary", "freetextmedication"];
export const showMyaccountNav = [
  "personalinfo",
  "staffauthorization",
  "clinicalinformation",
  "favouritedrugs",
  "prescription-template-info",
  "changepassword",
  "mybriefcase",
  "dashboard",
  "profile-settings",
];
export const showReportsNav = [
  "patientprescriptionreport",
  "prescriberhistoryreport",
  "savedprescriptionreport",
  "pendingrefillsreport",
  "useractivityreport",
  "patientmedicationreport",
  "patientpharmaciesreport",
  "prescriberepcssuccessransactions",
  "prescriberepcsfailedtransactions",
  "prescriberepcsaudit",
];
export const showRxPadTabNav = [
  "prescription-summary",
  "newrxpad",
  "SS Medication History",
  "ssmedicationhistory",
  "allergies",
  "savedprescriptions",
  "favoritedrugs",
  "medicationshistory",
];
export const activeClassMedicationHistoryTab = [
  "drugupdate",
  "medicationinactivation",
  "confirmreprintrefax",
  "cancelprescriptions",
];
export const activeClassSSMedicationHistoryTab = [
  "ssmedicationhistory",
  "ssmedicationhistory/records",
];
export const pathIndex = 1;
export const SigninCarouselContent = [
  {
    img: epcs,
    name: "Electronic Prescribing of Controlled Substances(EPCS)",
    description:
      "H2H, Digital Rx EPCS feature is fully certified and ready for use in all United States. With EPCS activated, prescribers will be able to e-prescribe most medications, including scheduled controlled substances, directly from H2H Digital Rx e-prescribing platform.",
    link: "https://info.h2hdigitalrx.com/help_center/epcs-enrollment/",
  },
  {
    img: servingphysicians,
    name: "Serving Physicians for 17+ Yrs",
    description:
      "H2H DigitalRx is an e-prescribing platform, which provides Physicians and their staff members with a safe, secure, and comprehensive method for generating prescriptions within the Physician's office, and routes the completed prescriptions to the pharmacy of the Patient's choice via the Surescripts network.",
    link: "https://info.h2hdigitalrx.com/",
  },
  {
    img: epa,
    name: "Electronic Prior Authorization for Faster Approvals",
    description:
      "H2H DRx in collaboration with Surescripts accelerate medication delivery by obtaining prior authorization in real time at the point of care through a fully integrated solution.",
    link: "https://info.h2hdigitalrx.com/help_center/how-to-initiate-electronic-prior-authorization-epa/",
  },
  {
    img: aipma,
    name: "AI-Powered Medical Adherence Prediction Solution",
    description:
      "The AI-powered Adherence Prediction Module by H2H Solutions enhances the Digital Rx platform, providing real-time insights and predicting medication adherence from a 365-day view for early intervention and improved outcomes.",
    link: "https://info.h2hdigitalrx.com/help_center/what-is-medical-adherence/",
  },
];

export const routes = [
  {
    component: Dashboard,
    path: "dashboard",
  },
  {
    component: NewRxPadSingle,
    path: "newrxpad/*",
  },
  {
    component: AIPrescription,
    path: "ai-prescription",
  },
  // {
  //   component: PrescriptionSummary,
  //   path: "prescription-summary",
  // },
  {
    component: SavedPrescriptions,
    path: "savedprescriptions",
  },
  {
    component: PrescriptionTemplate,
    path: "prescription-template",
  },
  {
    component: PrescriptionTemplateDetails,
    path: "prescription-template/:templateId",
  },
  {
    component: EPAHoldingQueueConfirmPresctiptions,
    path: "epaconfirmpresctions/*",
  },
  {
    component: AllSavedPrescriptions,
    path: "allsavedprescriptions",
  },
  {
    component: SSMedicationHistory,
    path: "ssmedicationhistory",
  },
  {
    component: PrescriptionFilled,
    path: "ssmedicationhistory/records",
  },
  {
    component: Allergies,
    path: "allergies",
  },
  {
    component: FavoriteDrugs,
    path: "favoritedrugs",
  },
  {
    component: MedicationHistory,
    path: "medicationshistory",
  },
  {
    component: LegacyHistory,
    path: "medicationshistory/legacy-history",
  },
  {
    component: PracticeFavoriteDrugs,
    path: "practicefavdrugs",
  },
  {
    component: Registration,
    path: "registration",
  },
  {
    component: Ticket,
    path: "ticket",
  },
  {
    component: Faqs,
    path: "faqs",
  },
  {
    component: HelpCenter,
    path: "help",
  },
  {
    component: NotificationsList,
    path: "notifications",
  },
  {
    component: ChangePassword,
    path: "changepassword",
  },
  {
    component: ProfileSettings,
    path: "profile-settings",
  },
  {
    component: EpcsQueue,
    path: "epcsqueue",
  },

  {
    component: PendingRefills,
    path: "pendingrefills",
  },
  {
    component: PendingRefillsAlert,
    path: "pendingrefillsalert",
  },
  {
    component: RxAlerts,
    path: "rxalerts",
  },
  {
    component: PendingRxChange,
    path: "pendingrxchange",
  },
  {
    component: PendingRxChangeAlerts,
    path: "pendingrxchangealerts",
  },
  {
    component: RxFill,
    path: "rxfill",
  },
  {
    component: RxFillAlert,
    path: "rxfillalert",
  },
  {
    component: EPAWorklist,
    path: "epaworklist",
  },
  {
    component: EPAHoldingQueue,
    path: "epaholdingqueue",
  },
  {
    component: PostDatedPrescriptions,
    path: "postdatedprescriptions",
  },
  {
    component: FreeTextMedicationSingle,
    path: "freetextmedication/*",
  },
  {
    component: DefaultPhysician,
    path: "defaultphysician",
  },
  {
    component: PracticeFavoriteDrugs,
    path: "practicefavoritedrugs",
  },
  {
    component: PatientProfile,
    path: "PatientInformation",
  },
  {
    component: AllergyInformation,
    path: "AllergyInformation",
  },
  {
    component: InsuranceInformation,
    path: "InsuranceInformation",
  },
  {
    component: PharmacyInformation,
    path: "PharmacyInformation",
  },

  {
    component: PatientSearch,
    path: "patientsearch",
  },
  {
    component: StaffAuthorization,
    path: "staffauthorization",
  },
  {
    component: PersonalInfo,
    path: "personalinfo",
  },
  {
    component: ClinicalInformation,
    path: "clinicalinformation",
  },
  {
    component: PrescriptionTemplateInfo,
    path: "prescription-template-info",
  },
  {
    component: PrescriptionTemplateInfoDetails,
    path: "prescription-template-info/:templateId",
  },
  {
    component: FavouriteDrugs,
    path: "favouritedrugs",
  },

  {
    component: PendingRefillAlertsRequest,
    path: "pendingrefillalertsrequest",
  },
  {
    component: PendingRefillsRequest,
    path: "pendingrefillsrequest",
  },
  {
    component: PendingRefillsAllergyInfo,
    path: "pendingrefillallergyinfo",
  },
  {
    component: RxAlertsReview,
    path: "rxalertsreview",
  },
  {
    component: RxFillReview,
    path: "rxfillreview",
  },
  {
    component: RxFillAlertReview,
    path: "rxfillalertreview",
  },
  {
    component: PendingRxChangeRequest,
    path: "pendingrxchangerequest",
  },
  {
    component: PendingRxChangeAllergyInfo,
    path: "pendingrxchangeallergyinfo",
  },
  {
    component: PendingRxChangeAlertsRequest,
    path: "pendingrxchangealertsrequest",
  },

  {
    component: MyBriefCase,
    path: "mybriefcase",
  },
  {
    component: PatientPrescriptionReport,
    path: "patientprescriptionreport",
  },
  {
    component: PrescriberHistoryReport,
    path: "prescriberhistoryreport",
  },
  {
    component: SavedPrescriptionReport,
    path: "savedprescriptionreport",
  },
  {
    component: PendingRefillsReport,
    path: "pendingrefillsreport",
  },
  {
    component: UserActivityReport,
    path: "useractivityreport",
  },
  {
    component: PatientMedicationReport,
    path: "patientmedicationreport",
  },
  {
    component: PatientPharmaciesReport,
    path: "patientpharmaciesreport",
  },
  {
    component: DrugUpdate,
    path: "drugupdate",
  },
  {
    component: MedicationInactivation,
    path: "medicationinactivation",
  },
  {
    component: ConfirmReprintRefax,
    path: "confirmreprintrefax",
  },
  {
    component: CancelPrescriptions,
    path: "cancelprescriptions",
  },
  {
    component: PrescriberEPCSSuccessransactions,
    path: "prescriberepcssuccessransactions",
  },
  {
    component: PrescriberEPCSFailedTransactions,
    path: "prescriberepcsfailedtransactions",
  },
  {
    component: PrescriberEPCSAudit,
    path: "prescriberepcsaudit",
  },
];
export const patientRegistration = [
  {
    id: 1,
    firstname: "firstname",
    lastname: "lastname",
    middlename: "middlename",
    prefix: "prefix",
    suffix: "suffix",
    Gender: "Gender",
    dateofbirth: "dateofbirth",
    address: "address",
    city: "city",
    state: "state",
    zip: "zip",
    country: "country",
    email: "email",
    confirmemail: "confirmemail",
    consent: "consent",
    teleponenumberhome: "teleponenumberhome",
    teleponenumberwork: "teleponenumberwork",
    weight: "weight",
    height: "height",
    allergicto: "allergicto",
    healthcondition: "healthcondition",
  },
];

export const leftNav = [
  {
    name: "Saved Rx (all Patients)",
    icon: SaveIcon,
    path: "/allsavedprescriptions",
    activeClass: "",
  },
  {
    name: "Practice Favorite Drugs",
    icon: DrugIcon,
    path: "/practicefavoritedrugs",
    activeClass: "",
  },
  {
    name: "Prescription Templates",
    icon: template,
    path: "/prescription-template",
    activeClass: "",
  },
  {
    name: "Free Text Medication",
    icon: FreeTextMedicationIcon,
    path: "/freetextmedication",
    activeClass: "",
  },
  {
    name: "Patient Profile",
    icon: PatientProfileIcon,
    path: "/PatientInformation",
    activeClass: "",
  },
  {
    name: "Default Physician",
    icon: DefaultPhysicianIcon,
    path: "/defaultphysician",
    activeClass: "",
  },
  {
    name: "Patient Registration",
    icon: PatientRegIcon,
    path: "/registration",
    activeClass: "",
  },
  {
    name: "Prescription Report",
    icon: PrescriptionReportIcon,
    path: "",
    activeClass: "",
  },
];
export const RxPadTabsNavLinks = [
  {
    name: "New Rx Pad",
    path: "/newrxpad",
    activeClass: "",
    class: "rxpadTab",
  },
];

export const FreeTextRxPadTabsNavLinks = [
  {
    name: "New Rx Pad",
    path: "/freetextmedication",
    activeClass: "",
    class: "rxpadTab",
  },
];
export const RxPadSummaryTabsNavLinks = [
  {
    name: "New Rx Pad",
    path: "/prescription-summary",
    activeClass: "",
    class: "rxpadSummaryTab",
  },
];
export const TabsNavLinks = [
  {
    name: "SS Medication History",
    path: "/ssmedicationhistory",
    activeClass: "",
    class: "ssMedicationHistoryTab",
  },
  {
    name: "Allergies",
    path: "/allergies",
    activeClass: "",
    class: "allergiesTab",
  },
  {
    name: "Saved Prescriptions",
    path: "/savedprescriptions",
    activeClass: "",
    class: "savedPrescriptionsTab",
  },

  {
    name: "Favorite Drugs",
    path: "/favoritedrugs",
    activeClass: "",
    class: "favoriteDrugsTab",
  },
  {
    name: "Medications History",
    path: "/medicationshistory",
    activeClass: "",
    class: "medicationHistoryTab",
  },
];

export const ProfileNavLinks = [
  {
    name: "Patient Information",
    path: "/PatientInformation",
    activeClass: "",
  },
  {
    name: "Allergy Information",
    path: "/AllergyInformation",
    activeClass: "",
  },
  {
    name: "Insurance Information",
    path: "/InsuranceInformation",
    activeClass: "",
  },
  {
    name: "Pharmacy Information",
    path: "/PharmacyInformation",
    activeClass: "",
  },
];

export const popupquicklinks = [
  {
    text: "Medication History",
    icon: MedicationHxIcon,
    path: "/medicationshistory",
  },
  {
    text: "Saved Prescriptions",
    icon: SavedRxIcon,
    path: "/savedprescriptions",
  },
  {
    text: "Favorite Drugs",
    icon: FavDrugIcon,
    path: "/favoritedrugs",
  },
];

export const EPAFiltersOptions = [
  {
    text: "New Rx",
    value: "newrx",
  },
  {
    text: "Refill",
    value: "refill",
  },
];

export const MHxFiltersOptions = [
  {
    text: "Complete History",
    value: "all",
  },
  {
    text: "Active Medication(s)",
    value: "active",
  },
  {
    text: "Inactive Medication(s)",
    value: "inactive",
  },
];

export const rxpadlink = [
  {
    name: "New Rx Pad",
    icon: NewRxPadIcon,
    path: "/newrxpad",
    activeClass: "",
  },
];
export const myaccountNav = [
  {
    name: "Personal Info",
    icon: MyAccountIcon,
    path: "/personalinfo",
    activeClass: "",
  },
  {
    name: "Staff Authorization",
    icon: StaffIcon,
    path: "/staffauthorization",
    activeClass: "",
  },
  {
    name: "Clinical Information",
    icon: ClinicIcon,
    path: "/clinicalinformation",
    activeClass: "",
  },
  {
    name: "Favorite Drugs",
    icon: FavIcon,
    path: "/favouritedrugs",
    activeClass: "",
  },
  {
    name: "Prescription Templates",
    icon: template,
    path: "/prescription-template-info",
    activeClass: "",
  },
  {
    name: "Set Drug Interaction Level",
    icon: SetDrugInteractionLevelIcon,
    path: "#",
    activeClass: "",
  },
  {
    name: "Change Password",
    icon: ChangePasswordIcon,
    path: "/changepassword",
    activeClass: "",
  },
  {
    name: "My BriefCase",
    icon: MybriefCaseIcon,
    path: "/mybriefcase",
    activeClass: "",
  },
  {
    name: "Profile Settings",
    icon: SettingsIcon,
    path: "/profile-settings",
    activeClass: "",
  },
];

export const reportsNav = [
  {
    name: "Patient Prescription",
    icon: PatientPrescriptionIcon,
    path: "/patientprescriptionreport",
    activeClass: "",
  },
  {
    name: "Prescriber History",
    icon: PrescriberHistoryIcon,
    path: "/prescriberhistoryreport",
    activeClass: "",
  },
  {
    name: "Saved Prescription",
    icon: SaveIcon,
    path: "/savedprescriptionreport",
    activeClass: "",
  },
  {
    name: "Pending Refills",
    icon: PendingRefillsIcon,
    path: "/pendingrefillsreport",
    activeClass: "",
  },
  {
    name: "User Activity",
    icon: UserActivityIcon,
    path: "/useractivityreport",
    activeClass: "",
  },
  {
    name: "Patient Medication",
    icon: PatientMedicationIcon,
    path: "/patientmedicationreport",
    activeClass: "",
  },
  {
    name: "Patient Pharmacies",
    icon: PatientPharmaciesIcon,
    path: "/patientpharmaciesreport",
    activeClass: "",
  },
  {
    name: "Prescriber EPCS  Success Transactions",
    icon: EPCSSuccessIcon,
    path: "/prescriberepcssuccessransactions",
    activeClass: "",
  },
  {
    name: "Prescriber EPCS Failed Transactions",
    icon: EPCSFailedIcon,
    path: "/prescriberepcsfailedtransactions",
    activeClass: "",
  },
  {
    name: "Prescriber EPCS Audit",
    icon: EPCSAuditIcon,
    path: "/prescriberepcsaudit",
    activeClass: "",
  },
];

export const countryOptions = [{ value: "US", label: "USA" }];

export const consentTypes = [
  {
    value: "Y",
    label: "Yes",
  },
  {
    value: "N",
    label: "No",
  },
  {
    value: "P",
    label: "Physician",
  },
];

export const rowstReportData = [
  {
    id: 1,
    name: "Winston Addington",
    address: "178 Paradise Crescent, , Royal Palm Beach,  ",
    telephone: "1234567890",
  },
  {
    id: 2,
    name: "Max Adroit",
    address: "123 Gunfort Line, , MG Mark, NJ, 00110",
    telephone: "1234567890",
  },
  {
    id: 3,
    name: "Jhon Glen",
    address: "178 Paradise Crescent, , Royal Palm Beach,  ",
    telephone: "1234567890",
  },
  {
    id: 4,
    name: "Mark Hamill",
    address: "123 Gunfort Line, , MG Mark, NJ, 00110",
    telephone: "1234567890",
  },
  {
    id: 5,
    name: "Max Adroit",
    address: "123 Gunfort Line, , MG Mark, NJ, 00110",
    telephone: "1234567890",
  },
];

export function TextNTooltip(prop: any) {
  return (
    <Typography className="textwrap" color={prop.color}>
      <Typography component="div" variant="body2" onClick={prop.onClick}>
        {!prop.Text ? "Not Available" : prop.Text + " "}{" "}
      </Typography>
      {prop.Text && (
        <HtmlTooltip
          placement="top"
          arrow
          title={!prop.Text ? "NA" : prop.Text + " "}
        >
          <IconButton className="tooltip">
            <img src={InfoIcon} alt="Tooltip" loading="lazy" />
          </IconButton>
        </HtmlTooltip>
      )}
    </Typography>
  );
}

export function DrugTextNTooltip(prop: any) {
  return (
    <Typography className="textwrap">
      {prop?.showPrintTooltip ? (
        <HtmlTooltip
          placement="right"
          arrow
          title={
            "This drug is not allowed for EPCS since it is already printed."
          }
        >
          <Typography
            component="div"
            variant="body2"
            onClick={prop.onClick}
            color={prop.color}
          >
            {prop?.row?.reprintRefaxFlag ? "** " : prop?.row?.oldSig && "* "}
            {prop.row.description ?? "NA"}
          </Typography>
        </HtmlTooltip>
      ) : (
        <Typography
          component="div"
          variant="body2"
          onClick={prop.onClick}
          color={prop.color}
        >
          {prop?.row?.reprintRefaxFlag ? "** " : prop?.row?.oldSig && "* "}
          {prop.row.description ?? "NA"}
        </Typography>
      )}

      <HtmlTooltip
        placement="right"
        arrow
        title={
          <DrugDscTooltip
            row={prop.row}
            needPharmacy={prop.needPharmacy}
            showInactivationDetails={prop.showInactivationDetails}
          />
        }
      >
        <IconButton className="tooltip">
          <img src={InfoIcon} alt="Tooltip" loading="lazy" />
        </IconButton>
      </HtmlTooltip>
    </Typography>
  );
}

export function PharmacyTextNTooltip(prop: any) {
  return (
    <Typography className="textwrap">
      <Typography component="div" variant="body2">
        {[null, ""].includes(prop.row.pharmacyName)
          ? "Not Available"
          : prop.row.pharmacyName}{" "}
      </Typography>
      <HtmlTooltip
        placement="right"
        arrow
        title={<PharmacyTooltip row={prop.row} />}
      >
        <IconButton className="tooltip">
          <img src={InfoIcon} alt="Tooltip" loading="lazy" />
        </IconButton>
      </HtmlTooltip>
    </Typography>
  );
}

export function PatientTextNTooltip(prop: any) {
  return (
    <Typography className="textwrap">
      <Typography component="div" variant="body2">
        {prop.row.patientFirstName} {prop.row.patientLastName}
      </Typography>
      <HtmlTooltip
        placement="right"
        arrow
        title={<PatientTooltip row={prop.row} />}
      >
        <IconButton className="tooltip">
          <img src={InfoIcon} alt="Tooltip" loading="lazy" />
        </IconButton>
      </HtmlTooltip>
    </Typography>
  );
}

export function TextNA(prop: any) {
  return (
    <Typography variant="body2" component={"div"} className="textwrap">
      {prop.Text === "" || prop.Text === null ? "Not Available" : prop.Text}
    </Typography>
  );
}

export function TextOnly(prop: any) {
  return (
    <Typography variant="body2" component={"div"} sx={{ ...prop?.sx }}>
      {prop.Text}
    </Typography>
  );
}

export function TextClick(prop: any) {
  return (
    <Typography
      onClick={prop.onClick}
      component="div"
      color="primary"
      variant="body2"
    >
      {prop.Text}
    </Typography>
  );
}

export function ViewClick(prop: any) {
  return (
    <Tooltip title="View">
      <IconButton color={prop.color} onClick={prop.onClick}>
        <img src={ShowPasswordIcon} alt="View" loading="lazy" />
      </IconButton>
    </Tooltip>
  );
}

export function PrintClick(prop: any) {
  return (
    <Tooltip title="Print">
      <IconButton color="primary" onClick={prop.onClick}>
        <img src={PrintGIcon} alt="Print" loading="lazy" />
      </IconButton>
    </Tooltip>
  );
}

export function MedicationHistoryNotes(prop: any) {
  return (
    <Tooltip title={prop.notes}>
      <IconButton
        color="primary"
        sx={{
          margin: "0px !important",
        }}
      >
        <img src={NotesIcon} alt="Notes" loading="lazy" />
      </IconButton>
    </Tooltip>
  );
}

export function PhoneTooltips(prop: any) {
  return (
    <TooltipCardStyle className="phone">
      <div>
        <a href={`tel:${prop.phone}`}>
          <Typography component="div" variant="h5" fontWeight={400}>
            {prop.phone ?? "Not Available"}
          </Typography>
        </a>
      </div>
      <IconButton className="closeIcon" onClick={prop.onClick}>
        <img src={ClosexIcon} alt="Close" loading="lazy" />
      </IconButton>
    </TooltipCardStyle>
  );
}

export function EmailTooltips(prop: any) {
  return (
    <TooltipCardStyle className="email">
      <div>
        <a href={`mailto:${prop.email}`}>
          <Typography component="div" variant="body1">
            {prop.email ?? "Not Available"}
          </Typography>
        </a>{" "}
      </div>
      <IconButton className="closeIcon" onClick={prop.onClick}>
        <img src={ClosexIcon} alt="Close" loading="lazy" />
      </IconButton>
    </TooltipCardStyle>
  );
}

export function LocTooltips(prop: any) {
  return (
    <TooltipCardStyle>
      <Typography component="div" variant="body2">
        {prop.address ?? "Not Available"}
      </Typography>{" "}
      <IconButton className="closeIcon" onClick={prop.onClick}>
        <img src={ClosexIcon} alt="Close" loading="lazy" />
      </IconButton>
    </TooltipCardStyle>
  );
}

export function InfoBtns(prop: any) {
  return (
    <div className="icons">
      <BtnIconStyle className="primary">
        <IconButton color="primary" onClick={prop.handleLocTooltipClick}>
          <img src={LocIcon} alt="Location" loading="lazy" />
        </IconButton>
      </BtnIconStyle>
      <BtnIconStyle className="primary email">
        <IconButton onClick={prop.handleEmailTooltipClick}>
          <img src={EmailIcon} alt="Email" loading="lazy" />{" "}
        </IconButton>
      </BtnIconStyle>
      <BtnIconStyle className="primary">
        <IconButton onClick={prop.handlePhoneTooltipClick}>
          <img src={PhoneIcon} alt="Phone" loading="lazy" />
        </IconButton>
      </BtnIconStyle>
    </div>
  );
}

export function FullUserInfo(prop: any) {
  // const [isReadMore, setIsReadMore] = useState(false);
  const [locTooltip, setLocTooltip] = useState(false);
  const handleLocTooltipClick = () => {
    setLocTooltip(!locTooltip);
    setEmailTooltip(false);
    setPhoneTooltip(false);
  };
  const [emailTooltip, setEmailTooltip] = useState(false);
  const handleEmailTooltipClick = () => {
    setEmailTooltip(!emailTooltip);
    setLocTooltip(false);
    setPhoneTooltip(false);
  };

  const [phoneTooltip, setPhoneTooltip] = useState(false);
  const handlePhoneTooltipClick = () => {
    setPhoneTooltip(!phoneTooltip);
    setLocTooltip(false);
    setLocTooltip(false);
  };
  return (
    <>
      <Typography component="div" variant="body1" fontWeight={400}>
        {prop?.title}
      </Typography>
      <Typography
        style={{ display: "flex", alignItems: "center" }}
        component="div"
        variant="subtitle1"
        color={"primary"}
      >
        <Typography
          component="div"
          variant="subtitle1"
          color={"primary"}
          className="wrap"
          style={{ margin: 0 }}
        >
          {prop?.name}
        </Typography>
        {prop?.PatientData ? (
          <HtmlTooltip
            placement="right"
            arrow
            title={
              <PatientDetailsFromToolTip
                patientDetailsData={prop?.PatientData}
              />
            }
          >
            <IconButton className="tooltip">
              <img src={InfoIcon} alt="Tooltip" loading="lazy" />
            </IconButton>
          </HtmlTooltip>
        ) : null}
      </Typography>
      {prop?.ptid && (
        <Typography component="div" variant="body2">
          <strong>Patient ID:</strong>
          <Typography fontSize={10}>{prop.ptid}</Typography>
        </Typography>
      )}
      {prop?.dob && prop?.age && prop?.gender && (
        <Typography component="div" variant="body2">
          {prop.dob} (<strong>{prop.age} Years Old</strong>), {prop.gender}
        </Typography>
      )}
      {prop?.weight && prop?.height && (
        <Typography component="div" variant="body2">
          <span>
            <strong>Wt: </strong> {prop.weight} (Lbs)
          </span>{" "}
          <span>
            <strong>Ht: </strong> {prop.height} (Inches)
          </span>
        </Typography>
      )}
      {prop?.dea && (
        <Typography
          component="div"
          variant="body2"
          style={{ wordBreak: "break-word" }}
        >
          <strong>DEA:</strong>
          {prop.dea}
          {/* {isReadMore ? prop.dea.join(", ") : prop.dea[0]},{" "} */}
          {/* <Typography
            variant="caption"
            fontWeight={500}
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={() => setIsReadMore(!isReadMore)}
          >
            {isReadMore ? "Read Less.." : "Read More.."}
          </Typography> */}
        </Typography>
      )}
      {prop?.spi && (
        <Typography component="div" variant="body2">
          <strong>SPI:</strong>
          {prop.spi}
        </Typography>
      )}
      {prop?.npi && (
        <Typography component="div" variant="body2">
          <strong>NPI:</strong>
          {prop.npi}
        </Typography>
      )}
      <Box style={{ position: "relative" }}>
        <InfoBtns
          handleLocTooltipClick={handleLocTooltipClick}
          handleEmailTooltipClick={handleEmailTooltipClick}
          handlePhoneTooltipClick={handlePhoneTooltipClick}
        />
        {locTooltip && (
          <LocTooltips address={prop.address} onClick={handleLocTooltipClick} />
        )}
        {emailTooltip && (
          <EmailTooltips email={prop.email} onClick={handleEmailTooltipClick} />
        )}
        {phoneTooltip && (
          <PhoneTooltips phone={prop.phone} onClick={handlePhoneTooltipClick} />
        )}
      </Box>
    </>
  );
}

export function PatientDetailsFromToolTip(prop: any) {
  const { patientDetailsData } = prop;
  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Patient Id:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.hostPatientId
              ? "Not Available"
              : patientDetailsData?.hostPatientId}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.patientName
              ? "Not Available"
              : patientDetailsData?.patientName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Date of Birth:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.dateOfBirth
              ? "Not Available"
              : patientDetailsData?.dateOfBirth}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Age:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.age
              ? "Not Available"
              : patientDetailsData?.age}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Address:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.address
              ? "Not Available"
              : patientDetailsData?.address}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Allergetic To:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.allergies
              ? "Not Available"
              : patientDetailsData?.allergies.join(", ")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Health Condition:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.healthCondition
              ? "Not Available"
              : patientDetailsData?.healthCondition}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Weight:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.weight
              ? "Not Available"
              : patientDetailsData?.weight}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Height:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.height
              ? "Not Available"
              : patientDetailsData?.height}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Home Phone:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.homeTelephone
              ? "Not Available"
              : patientDetailsData?.homeTelephone}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Work Phone:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.workPhoneNumber
              ? "Not Available"
              : patientDetailsData?.workPhoneNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Primary Insurance:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.primaryInsurance
              ? "Not Available"
              : patientDetailsData?.primaryInsurance}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Secondary Insurance:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.secondaryInsurance[0]
              ? "Not Available"
              : patientDetailsData?.secondaryInsurance[0]?.insuranceName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Patient is Allergetic To:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.allergies
              ? "Not Available"
              : patientDetailsData?.allergies.join(", ")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Active Medications:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!patientDetailsData?.medications
              ? "Not Available"
              : patientDetailsData?.medications.join(", ")}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export function MiniUserInfo(prop: any) {
  return (
    <>
      <Typography component="div" variant="subtitle1">
        <Avatar> {prop.name}</Avatar>
      </Typography>
      {prop.weight && (
        <Typography component="div" variant="body2">
          <Typography component="div" variant="body2" fontWeight={600}>
            W
          </Typography>
          {prop.weight}
        </Typography>
      )}
      {prop.height && (
        <Typography component="div" variant="body2">
          <Typography component="div" variant="body2" fontWeight={600}>
            H
          </Typography>
          {prop.height}
        </Typography>
      )}
      {prop.age && (
        <Typography component="div" variant="body2">
          <div>
            <strong>A</strong>
          </div>
          {prop.age} Years
        </Typography>
      )}
      {prop.gender && (
        <Typography component="div" variant="body2">
          <div>
            <strong>G</strong>
          </div>
          {prop.gender}
        </Typography>
      )}
    </>
  );
}

export function PatientInfoCard(prop: any) {
  return (
    <InfoCard>
      <Grid container spacing={1}>
        <Grid item xs={6} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Name:
          </Typography>
          <Typography component={"div"} variant={"body2"} className="ptName">
            {prop.name}
          </Typography>
        </Grid>
        <Grid item xs={6} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Patient ID:
          </Typography>
          <Typography component={"div"} variant={"body2"} className="ptId">
            {prop.patientId}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Age:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.age}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Phone:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.telePhone}
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Address:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.address}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            SSN:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.ssn}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            DOB:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.dateOfBirth}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Gender:
          </Typography>
          <Typography component={"div"} variant={"body2"}>
            {prop.gender}
          </Typography>
        </Grid>
      </Grid>
    </InfoCard>
  );
}

export function PatientPharmacyInfoCard({
  PatientInfo,
  PharmacyInfo,
}: {
  PatientInfo: any;
  PharmacyInfo: any;
}) {
  return (
    <>
      <PatientPharmaInfoCard>
        <Box className="patientInfo">
          <Box className="title">
            <img
              src={PatientProfIcon}
              alt="Patient Profile"
              loading="lazy"
              width="42px"
              height="42px"
            />

            <Typography
              variant="caption"
              fontSize={14}
              fontWeight={400}
              color="primary"
              fontStyle={"normal"}
              component={"div"}
            >
              <strong> Patient </strong> Information
            </Typography>
          </Box>
          <Box className="content">
            <Typography component={"span"} variant={"body2"}>
              <strong> Name: </strong>
              <span>
                {PatientInfo?.patientName ? PatientInfo?.patientName : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong> Patient ID: </strong>
              <span>
                {PatientInfo?.patientId ? PatientInfo?.patientId : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong> Address: </strong>
              <span>
                {PatientInfo?.patientAddress
                  ? PatientInfo?.patientAddress
                  : "N/A"}
              </span>
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong> Age: </strong>
                <span>
                  {PatientInfo?.patientAge ? PatientInfo?.patientAge : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong> Phone: </strong>
                <span>
                  {PatientInfo?.patientWorkPhone
                    ? PatientInfo?.patientWorkPhone
                    : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong> Gender: </strong>
                <span>
                  {PatientInfo?.patientGender
                    ? PatientInfo?.patientGender
                    : "N/A"}
                </span>
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="pharmacyInfo">
          <Box className="title">
            <img
              src={PharmacyProfileIcon}
              alt="Pharmacy Profile"
              loading="lazy"
            />
            <Typography
              variant="caption"
              fontSize={14}
              fontWeight={400}
              color="primary"
              fontStyle={"normal"}
              component={"div"}
            >
              <strong> Pharmacy </strong> Information
            </Typography>
          </Box>
          <Box className="content">
            <Typography component={"span"} variant={"body2"}>
              <strong> Name:</strong>
              <span>
                {PharmacyInfo?.pharmacyName
                  ? PharmacyInfo?.pharmacyName
                  : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong>Address:</strong>
              <span>
                {PharmacyInfo?.address ? PharmacyInfo?.address : "N/A"}
              </span>
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Zip:</strong>
                <span>{PharmacyInfo?.zip ? PharmacyInfo?.zip : "N/A"}</span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>City:</strong>
                <span>{PharmacyInfo?.city ? PharmacyInfo?.city : "N/A"}</span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>State:</strong>
                <span>{PharmacyInfo?.state ? PharmacyInfo?.state : "N/A"}</span>
              </Typography>
            </Box>{" "}
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Phone:</strong>
                <span>{PharmacyInfo?.phone ? PharmacyInfo?.phone : "N/A"}</span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Fax:</strong>
                <span>{PharmacyInfo?.fax ? PharmacyInfo?.fax : "N/A"}</span>
              </Typography>
            </Box>
          </Box>
        </Box>
      </PatientPharmaInfoCard>
    </>
  );
}

export const PharmacyDetailsList = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyName)
            ? "Not Available"
            : row.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.hoursOfService)
            ? "Not Available"
            : row.hoursOfService}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.store) ? "Not Available" : row.store}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.address) ? "Not Available" : row.address}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.landMark) ? "Not Available" : row.landMark}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.city) ? "Not Available" : row.city}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.state) ? "Not Available" : row.state}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.zip) ? "Not Available" : row.zip}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.phone) ? "Not Available" : row.phone}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.fax) ? "Not Available" : row.fax}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const mobilequicklinks = [
  {
    name: "My Profile",
    icon: MyAccountIcon,
    path: "/personalinfo",
    activeClass: "",
  },
  {
    name: "Notifications",
    icon: NotificationIcon,
    path: "/notifications",
    activeClass: "",
  },
  {
    name: "Dashboard",
    icon: DashboardIcon,
    path: "/dashboard",
    activeClass: "",
  },
  {
    name: "Patient Search",
    icon: SearchIcon,
    path: "/patientsearch",
    activeClass: "",
  },
  {
    name: "Raise a support ticket",
    icon: TicketIcon,
    path: "/ticket",
    activeClass: "",
  },
  {
    name: "FAQs",
    icon: FaqIcon,
    path: "/faqs",
    activeClass: "",
  },
  {
    name: "Help",
    icon: HelpIcon,
    path: "/help",
    activeClass: "",
  },
  {
    name: "Reports",
    icon: ReportsIcon,
    path: "/patientprescriptionreport",
    activeClass: "",
  },
];

export const EPAStatusDetails = (props: any) => {
  const { rowData } = props;
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Overall EPA Status:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} textAlign="left">
          <Typography component={"div"} variant={"body2"}>
            {rowData?.overallEpaStatus ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Current Status:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} textAlign="left">
          <Typography component={"div"} variant={"body2"}>
            {rowData?.currentStatus ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            PA Reference Id:
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} textAlign="left">
          <Typography component={"div"} variant={"body2"}>
            {rowData?.rxssmsgNumber ?? "Not Available"}
          </Typography>
        </Grid>
        {rowData?.epaDescription && (
          <Grid item xs={12} md={12}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              {rowData?.epaDescription}
            </Typography>
          </Grid>
        )}
        {rowData?.paResponseDetails?.paNote && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Note:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paNote ?? "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paCaseId && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Case Id:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paCaseId ?? "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paClosedReasonCode && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Closed Reason Code:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paClosedReasonCode?.toString() ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paClosedReasonDesc && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Closed Reason Description:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paClosedReasonDesc ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paAuthorizationNumber && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Authorization Number:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paAuthorizationNumber ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paApprovedQty !== 0 && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Approved Quantity:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paApprovedQty ?? "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paApprovedDaysSupply !== 0 && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Approved Days Supply:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paApprovedDaysSupply ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paApprovedRefills !== 0 && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Approved Refills:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paApprovedRefills ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paAuthEffectiveDate && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Auth Effective Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paAuthEffectiveDate ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.paAuthExpiryDate && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                PA Auth Expiry Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.paAuthExpiryDate ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.deadlineForReply && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Deadline For Reply:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.deadlineForReply ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.payerMailId && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Payer Mail Id:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.payerMailId ?? "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.payerPrimaryTelephone && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                Payer Phone Number:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.payerPrimaryTelephone ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
        {rowData?.paResponseDetails?.eAppealSupported && (
          <Grid item xs={12} md={12}>
            <Typography
              color={"primary"}
              component={"div"}
              variant={"body2"}
              fontWeight={600}
            >
              EAppeal Is Supported.
            </Typography>
          </Grid>
        )}
        {rowData?.paResponseDetails?.eAppealExpiryDate && (
          <>
            <Grid item xs={12} md={3}>
              <Typography component={"div"} variant={"body2"} fontWeight={600}>
                EAppeal Expiry Date:
              </Typography>
            </Grid>
            <Grid item xs={12} md={9} textAlign="left">
              <Typography component={"div"} variant={"body2"}>
                {rowData?.paResponseDetails?.eAppealExpiryDate ??
                  "Not Available"}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};
